var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balloon",on:{"click":_vm.handleOpenNewTabWhatsapp}},[_c('v-icon',{attrs:{"color":"white","size":"35"}},[_vm._v("mdi-whatsapp")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }